<template>
    <div>
        <div class="global-header">
            <nav class="container navbar navbar-light" style="padding-left: 15px">
                <a class="d-flex justify-content-between" href="#" v-on:click="back()">
                    <svg class="back-icon align-self-center" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="34" height="34">
                        <path d="M0 0h24v24H0z" fill="none" />
                        <path d="M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z" />
                    </svg>
                    <div class="navbar-text align-self-center">{{ $t("Back") }}</div>
                </a>
            </nav>
        </div>

        <div class="container main-content">
            <div class="row">
                <div class="col-12">
                    <div class="filters-section">
                        <h2>{{ $t("Filters") }}</h2>
                        <hr>
                        <ul class="filters">
                            <li v-for="tag in tags" :key="tag.id" class="mb-3">
                                <div class="checkbox form-check form-check-inline">
                                    <input class="form-check-input" type="checkbox" v-on:click="updateTags" :id="`tag-${tag.id}`" :checked="tag.enabled" :value="tag.id">
                                    <label class="form-check-label" :for="`tag-${tag.id}`">{{ tag.name }}</label>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="filters-section">
                        <h2>{{ $t("I am allergic to") }}</h2>
                        <hr>
                        <ul class="filters">
                            <li v-for="allergen in allergens" :key="allergen.id">
                                <div class="checkbox form-check form-check-inline">
                                    <input class="form-check-input" type="checkbox" v-on:click="updateAllergens" :id="`allergen-${allergen.id}`" :checked="allergen.enabled" :value="allergen.id">
                                    <label class="form-check-label" :for="`allergen-${allergen.id}`">{{ allergen.name }}</label>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="container global-footer">
            <div class="d-flex justify-content-between my-4">
                <div>
                    <button type="button" class="btn btn-reset" v-on:click="reset">{{ $t("Reset") }}</button>
                </div>
                <div>
                    <button type="button" class="btn btn-primary" v-on:click="apply">{{ $t("Apply") }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            tags: [],
            allergens: []
        }
    },
    methods: {
        fetch() {
            this.$axios
                .get(`/filters`)
                .then(response => {
                    this.allergens = response.data.allergens;

                    let enabled_allergens = (this.$route.query.allergens || '').split(',');

                    this.allergens.forEach(a => {
                        if (enabled_allergens.includes(a.id.toString())) {
                            a.enabled = true;
                        }
                    });

                    this.tags = response.data.tags;

                    let enabled_tags = (this.$route.query.tags || '').split(',');

                    this.tags.forEach(a => {
                        if (enabled_tags.includes(a.id.toString())) {
                            a.enabled = true;
                        }
                    });
                });
        },
        updateAllergens(event) {
            if (event) {
                this.allergens.find(a => a.id == event.target.value).enabled = event.target.checked;
            }

            let enabled_allergens = this.allergens.filter(a => a.enabled == true).map(a => { return a.id });

            const query = Object.assign({}, this.$route.query);
            query.allergens = enabled_allergens.toString();

            this.$router.push({ query });
        },
        updateTags(event) {
            if (event) {
                this.tags.find(a => a.id == event.target.value).enabled = event.target.checked;
            }

            let enabled_tags = this.tags.filter(a => a.enabled == true).map(a => { return a.id });

            const query = Object.assign({}, this.$route.query);
            query.tags = enabled_tags.toString();

            this.$router.push({ query });
        },
        reset() {
            this.allergens.map(a => a.enabled = false);
            this.tags.map(a => a.enabled = false);

            this.updateAllergens();
            this.updateTags();

            this.$router.push({ path: window.location.pathname.replace('/filters', ''), query: this.$route.query });
        },
        apply() {
            this.$router.push({ path: window.location.pathname.replace('/filters', ''), query: this.$route.query });
        },
        back() {
            this.$router.push({ path: window.location.pathname.replace('/filters', ''), query: this.$route.query });
        }
    },
    mounted() {
        this.fetch();

        this.$pageTitle = this.$t("Filters");
    }
}
</script>
